"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApTrendWidget = void 0;
var React = require("react");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetMidValue_1 = require("../ApWidgetMidValue");
var ApWidgetName_1 = require("../ApWidgetName");
var styles_1 = require("./styles");
var SINGLE_ROW_VALUE_HEIGTH = 50;
exports.ApTrendWidget = function (_a) {
    var data = _a.data, dataError = _a.dataError, config = _a.config, props = __rest(_a, ["data", "dataError", "config"]);
    var valueRef = React.useRef();
    var _b = __read(React.useState(0), 2), valueElHeight = _b[0], setValueElHeight = _b[1];
    React.useLayoutEffect(function () {
        if (valueRef && valueRef.current) {
            setValueElHeight(valueRef.current.clientHeight);
        }
    });
    // truncate data list, to show items that can fit into available height
    var isValueSingleRow = valueElHeight <= SINGLE_ROW_VALUE_HEIGTH;
    var dataListMaxLength = isValueSingleRow ? 3 : 2;
    if (config && config.heightRatio === 2) {
        dataListMaxLength = isValueSingleRow ? 12 : 11;
    }
    return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
        React.createElement(styles_1.StyledWidgetWrapper, null,
            config && (React.createElement(ApWidgetName_1.ApWidgetName, { name: config.name, iconType: config.iconType })),
            dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : !data ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : (React.createElement(styles_1.Container, null,
                React.createElement(styles_1.TextWrapper, { ref: valueRef },
                    React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, null, data.value),
                    React.createElement(ApWidgetMidValue_1.ApWidgetMidValue, null,
                        React.createElement(styles_1.ValueHelperText, null, "vendors in\u00A0"),
                        React.createElement(styles_1.ValueText, null, data.label))),
                React.createElement(styles_1.Table, null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement(styles_1.TableHeader, null, "Top Categories"),
                            React.createElement(styles_1.TableHeader, null, "Change"))),
                    React.createElement("tbody", null, data.list &&
                        data.list
                            .slice(0, dataListMaxLength)
                            .map(function (listItem, index) { return (React.createElement(styles_1.TableRow, { key: index },
                            React.createElement(styles_1.TableCell, null, listItem.label),
                            React.createElement(styles_1.TableValueCell, null, listItem.value))); }))))))));
};
//# sourceMappingURL=ApTrendWidget.js.map